export enum ResourceType {
  Patient = 'Patient',
  Doctor = 'Doctor',
  Practitioner = 'Practitioner',
  RelatedPerson = 'RelatedPerson',
}